"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptSlotsComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const form_parts_1 = require("../form-parts");
const slots_types_1 = require("./types/slots.types");
const backendImport_1 = require("@front/backendImport");
const defaultGoals = [
    { label: 'slot.none'.t(), value: null },
    { label: 'slot.goal.efficiency'.t(), value: 'slot.goal.efficiency'.t() },
    { label: 'slot.goal.accuracy'.t(), value: 'slot.goal.accuracy'.t() },
    { label: 'slot.goal.creativity'.t(), value: 'slot.goal.creativity'.t() },
    { label: 'slot.goal.detail'.t(), value: 'slot.goal.detail'.t() },
];
const defaultTargets = [
    { label: 'slot.target.self'.t(), value: null },
    { label: 'slot.target.client'.t(), value: 'slot.target.client'.t() },
    { label: 'slot.target.coworker'.t(), value: 'slot.target.coworker'.t() },
    { label: 'slot.target.manager'.t(), value: 'slot.target.manager'.t() },
];
//@ts-ignore                
let rwsTemplate = T.html `<div id="slot-prompt-container" class="slot-prompt-container">
    <the-form horizontal="true" gap="10px" justifyContent="flex-start" alignItems="center">
        <div class="slot-item">
            <rws-tooltip side="right" text="${'slot.prompt_context'.t()}">
                <i class="iconsminds-data-center"></i>
            </rws-tooltip>
            <part-input class="no-margin rounded" type="text" name="conversation_context" placeholder="${'slot.prompt_context'.t()}"></part-input>
        </div>
        <div class="slot-item">
            <rws-tooltip text="${'slot.conversation_goal'.t()}">
                <i class="iconsminds-target"></i>
            </rws-tooltip>
            <v-select :value="${x => x.form.conversation_goal}" @change="${(x, c) => x.changeGoal(c.event)}" @createItem="${(x, c) => x.handleCreateItem(c.event)}" id="goal-select" allowCreation="true" side="top" class="no-margin rounded" :choiceList="${x => x.goalOpts}" name="conversation_goal"></v-select>
        </div>
        <div class="slot-item">
            <rws-tooltip text="${'slot.conversation_target'.t()}">
                <i class="iconsminds-user"></i>
            </rws-tooltip>
            <v-select :value="${x => x.form.conversation_target}" @change="${(x, c) => x.changeTarget(c.event)}" @createItem="${(x, c) => x.handleCreateItem(c.event)}" id="target-select" allowCreation="true" side="top" class="no-margin rounded" :choiceList="${x => x.targetOpts}" name="conversation_target"></v-select>            
        </div>
        <div class="slot-item">
            <rws-tooltip text="${'slot.conversation_format'.t()}">
                <i class="iconsminds-file"></i>
            </rws-tooltip>
            <part-select class="no-margin rounded" :options="${x => x.formatOpts}" name="conversation_format"></part-select>
        </div>
    </the-form>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.slot-prompt-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.slot-prompt-container .slot-item {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.slot-prompt-container .slot-item i {
  margin-right: 10px;
}
.slot-prompt-container .slot-item part-input {
  min-width: 200px;
}

v-select {
  width: 200px;
}`;
const shadowOptions = { "mode": "open" };
let PromptSlotsComponent = class PromptSlotsComponent extends client_1.RWSViewComponent {
    constructor() {
        super();
        this.form = {
            conversation_context: null,
            conversation_goal: null,
            conversation_target: null,
            conversation_format: null
        };
        this.goalOpts = defaultGoals;
        this.targetOpts = defaultTargets;
        this.formatOpts = [
            { label: 'slot.none'.t(), value: null },
            { label: 'slot.format.pdf'.t(), value: 'PDF' },
            { label: 'slot.format.csv'.t(), value: 'CSV' }
        ];
    }
    async connectedCallback() {
        super.connectedCallback();
        form_parts_1.FormComponent.listenForValuesChange.bind(this)('form');
        // Load slot data from database
        await this.loadSlotData();
    }
    async loadSlotData() {
        try {
            const response = await this.apiService.back.get('ai.get-slot-data');
            const removeCallback = async (target) => {
                try {
                    console.log({ target, form: this.form });
                    if (target.type === backendImport_1.SlotDataType.GOAL && target.value === this.form.conversation_goal) {
                        this.form = { ...this.form, conversation_goal: null };
                        this.emitChange();
                    }
                    if (target.type === backendImport_1.SlotDataType.TARGET && target.value === this.form.conversation_target) {
                        this.form = { ...this.form, conversation_target: null };
                        this.emitChange();
                    }
                    const deleteResponse = await this.apiService.back.delete('ai.delete-slot-data', { routeParams: { id: String(target.id) } });
                    if (deleteResponse && deleteResponse.success) {
                        this.notifyService.notify(`slot-data.deleted`.t() + ': ' + target.label);
                        await this.loadSlotData();
                    }
                    else {
                        console.error('Failed to delete slot data:', (deleteResponse === null || deleteResponse === void 0 ? void 0 : deleteResponse.error) || 'Unknown error');
                    }
                }
                catch (error) {
                    console.error('Error deleting slot data:', error);
                }
            };
            if (response && response.success && response.data) {
                const dbGoals = response.data.goals.map(goal => ({
                    label: goal.label,
                    value: goal.value,
                    actions: [{
                            icon: 'close',
                            tooltip: 'crud.delete'.t(),
                            callback: async () => {
                                await removeCallback(goal);
                            }
                        }]
                }));
                this.goalOpts = [...defaultGoals, ...dbGoals];
                const dbTargets = response.data.targets.map(target => ({
                    label: target.label,
                    value: target.value,
                    actions: [{
                            icon: 'close',
                            tooltip: 'crud.delete'.t(),
                            callback: async () => {
                                await removeCallback(target);
                            }
                        }]
                }));
                this.targetOpts = [...defaultTargets, ...dbTargets];
            }
        }
        catch (error) {
            console.error('Failed to load slot data:', error);
        }
    }
    changeGoal(event) {
        this.form = { ...this.form, conversation_goal: event.detail.value };
    }
    changeTarget(event) {
        this.form = { ...this.form, conversation_target: event.detail.value };
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    async handleCreateItem(event) {
        var _a;
        const { value, label } = event.detail;
        // Get the field name from the event target's name attribute
        const fieldName = ((_a = event.target) === null || _a === void 0 ? void 0 : _a.name) || '';
        // Map field names to slot types based on the form structure
        let slotType;
        switch (fieldName) {
            case 'conversation_goal':
                slotType = backendImport_1.SlotDataType.GOAL;
                break;
            case 'conversation_target':
                slotType = backendImport_1.SlotDataType.TARGET;
                break;
            default:
                return; // Only handle goal and target fields
        }
        try {
            const response = await this.apiService.back.post('ai.create-slot-data', {
                label,
                value,
                type: slotType
            });
            if (response && response.success) {
                this.notifyService.notify(`slot-data.created`.t() + ': ' + label);
                // Refresh slot data to include the new item
                await this.loadSlotData();
            }
            else {
                console.error('Failed to create slot data:', (response === null || response === void 0 ? void 0 : response.error) || 'Unknown error');
            }
        }
        catch (error) {
            console.error('Error creating slot data:', error);
        }
    }
    emitChange() {
        this.$emit('change', this.form);
    }
    get value() {
        return this.form;
    }
};
exports.PromptSlotsComponent = PromptSlotsComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof slots_types_1.IPromptSlotsContent !== "undefined" && slots_types_1.IPromptSlotsContent) === "function" ? _a : Object)
], PromptSlotsComponent.prototype, "form", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], PromptSlotsComponent.prototype, "goalOpts", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], PromptSlotsComponent.prototype, "targetOpts", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], PromptSlotsComponent.prototype, "formatOpts", void 0);
exports.PromptSlotsComponent = PromptSlotsComponent = __decorate([
    (0, client_1.RWSView)('prompt-slots', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __metadata("design:paramtypes", [])
], PromptSlotsComponent);
PromptSlotsComponent.defineComponent();
